/* Style Slider — Swiper-based horizontal rail of style/fit cards. Hook: .style-slider. */
(function () {
  /* watchOverflow (+ the slidesOffsetBefore fix already in place) correctly
     locks Swiper's own touch/drag handling and grab cursor when content
     doesn't overflow — but in this Swiper version the Mousewheel module's own
     wheel/trackpad handling does NOT reliably respect that locked state, so a
     laptop two-finger scroll could still nudge the translate even with zero
     real overflow. This checks the ACTUAL rendered width directly and, when
     there's nothing to scroll, explicitly disables touch move and the
     mousewheel module (not just a Swiper option) and forces the wrapper back
     to translate 0 — rather than trusting Swiper's internal lock state alone. */
  function syncOverflowLock(swiper, swiperEl) {
    if (!swiper || swiper.destroyed) return;

    var hasOverflow = swiperEl.scrollWidth > swiperEl.clientWidth + 1;

    if (hasOverflow) {
      swiper.allowTouchMove = true;
      swiper.allowSlideNext = true;
      swiper.allowSlidePrev = true;
      if (swiper.mousewheel && typeof swiper.mousewheel.enable === 'function' && !swiper.mousewheel.enabled) {
        swiper.mousewheel.enable();
      }
    } else {
      swiper.allowTouchMove = false;
      swiper.allowSlideNext = false;
      swiper.allowSlidePrev = false;
      if (swiper.mousewheel && typeof swiper.mousewheel.disable === 'function' && swiper.mousewheel.enabled) {
        swiper.mousewheel.disable();
      }

      /* Force the wrapper back to its resting position in case a gesture
         already nudged the translate before this ran (e.g. right at init,
         before layout/images settle). */
      if (swiper.translate !== 0) {
        swiper.setTranslate(0);
        swiper.updateProgress(0);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
      }
    }
  }

  function initStyleSlider(root) {
    if (!root || root.dataset.styleSliderInit === '1') return;
    if (typeof Swiper === 'undefined') return;

    var swiperEl = root.querySelector('.style-slider__swiper');
    if (!swiperEl) return;

    root.dataset.styleSliderInit = '1';

    var spaceBetween = parseInt(swiperEl.dataset.spaceBetween, 10);
    if (isNaN(spaceBetween)) spaceBetween = 8;

    var spaceBetweenDesktop = parseInt(swiperEl.dataset.spaceBetweenDesktop, 10);
    if (isNaN(spaceBetweenDesktop)) spaceBetweenDesktop = spaceBetween;

    var swiper = new Swiper(swiperEl, {
      slidesPerView: 'auto',
      spaceBetween: spaceBetween,
      grabCursor: true,
      watchOverflow: true,
      slidesOffsetBefore: 1,
      mousewheel: {
        forceToAxis: true
      },
      keyboard: {
        enabled: true,
        onlyInViewport: true
      },
      a11y: {
        enabled: true
      },
      breakpoints: {
        0: {
          spaceBetween: spaceBetween,
        },
        750: {
          spaceBetween: spaceBetweenDesktop,
        }
      },
      on: {
        init: function (sw) { syncOverflowLock(sw, swiperEl); },
        resize: function (sw) { syncOverflowLock(sw, swiperEl); },
        breakpoint: function (sw) { syncOverflowLock(sw, swiperEl); },
        observerUpdate: function (sw) { syncOverflowLock(sw, swiperEl); }
      }
    });

    root.styleSliderInstance = swiper;

    /* Belt-and-suspenders on top of Swiper's own `resize`/`breakpoint` events —
       covers card images/fonts still settling after the `init` measurement.
       `window.addEventListener('load', ...)` never fires if 'load' already
       happened before this ran (common: Theme Editor section reloads, or a
       deferred script executing after the page finished loading) — in that
       case a double-rAF recheck stands in for it instead, so there's always
       at least one late recheck regardless of when init happened relative to
       page load. */
    if (document.readyState !== 'complete') {
      window.addEventListener('load', function () { syncOverflowLock(swiper, swiperEl); }, { once: true });
    } else {
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { syncOverflowLock(swiper, swiperEl); });
      });
    }

    var overflowResizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(overflowResizeTimer);
      overflowResizeTimer = setTimeout(function () { syncOverflowLock(swiper, swiperEl); }, 150);
    });
  }

  function destroyStyleSlider(root) {
    if (root && root.styleSliderInstance) {
      root.styleSliderInstance.destroy(true, true);
      root.styleSliderInstance = null;
    }
    if (root) root.dataset.styleSliderInit = '';
  }

  /* Smooth-scrolls same-page anchor links (e.g. #traveler) used by Style
     Slider cards, instead of the browser's default instant jump. Entirely
     separate from the Swiper setup above — doesn't touch slider config,
     markup, or styling. Normal internal/external links are left alone. */
  function getSamePageAnchorId(href) {
    if (!href) return null;

    var hashIndex = href.indexOf('#');
    if (hashIndex === -1) return null;

    var id = href.slice(hashIndex + 1);
    if (!id) return null;

    var link;
    try {
      link = document.createElement('a');
      link.href = href;
    } catch (e) {
      return null;
    }

    var sameOrigin = link.origin === window.location.origin;
    var samePath = link.pathname === window.location.pathname;
    var sameSearch = link.search === window.location.search;

    if (!sameOrigin || !samePath || !sameSearch) return null;

    return id;
  }

  function initAnchorScroll(root) {
    if (!root || root.dataset.anchorScrollInit === '1') return;
    root.dataset.anchorScrollInit = '1';

    root.addEventListener('click', function (event) {
      var link = event.target.closest('a.style-slider__card');
      if (!link || !root.contains(link)) return;

      var anchorId = getSamePageAnchorId(link.getAttribute('href'));
      if (!anchorId) return;

      var target = document.getElementById(anchorId);
      if (!target) return;

      event.preventDefault();

      var headerHeight = 0;
      var headerHeightValue = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
      if (headerHeightValue) {
        headerHeight = parseFloat(headerHeightValue) || 0;
      }

      var scrollOffset = 50;
      var targetTop = target.getBoundingClientRect().top + window.pageYOffset - headerHeight - scrollOffset;

      var prefersReducedMotion = window.matchMedia
        && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      window.scrollTo({
        top: targetTop,
        behavior: prefersReducedMotion ? 'auto' : 'smooth'
      });

      if (window.history && window.history.pushState) {
        window.history.pushState(null, '', '#' + anchorId);
      }
    });
  }

  function boot() {
    var nodes = document.querySelectorAll('.style-slider');
    for (var i = 0; i < nodes.length; i++) {
      initStyleSlider(nodes[i]);
      initAnchorScroll(nodes[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target && event.target.querySelector
      ? event.target.querySelector('.style-slider')
      : null;
    destroyStyleSlider(root);
  });
})();
